"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoadingSpinner = require("./LoadingSpinner.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// Resources

/**
 * Loading spinner icon/component - not typically used alone.
 */
// intentionally left as a functional component
var LoadingSpinner = function LoadingSpinner(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement(_LoadingSpinner.StyledLoadingSpinner, {
    className: className,
    colorTheme: "primary",
    dataTestId: dataTestId,
    iconName: "spinner",
    size: size
  });
};

LoadingSpinner.propTypes = {
  /** class name hook for styling */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Size of Icon */
  size: _propTypes.default.oneOf([undefined, 'small', 'default', 'large', 'mediumLarge', 'extraLarge'])
};
LoadingSpinner.defaultProps = {
  className: '',
  size: 'extraLarge'
};
var _default = LoadingSpinner;
exports.default = _default;